// theme.js
export const theme = {
  primaryDark: '#0D0C1D',
  primaryLight: '#EFFFFA',
  primaryHover: '#343078',
  smallDesktop: '992px',
  tablet: '768px',
  mobile: '575px',
}
